import React, { useState, useEffect } from 'react';
import { SettingsStyles } from './Settings.styles';
import { CloseIcon, Select } from 'components';
import { LanguageList } from 'assert/OptionList';
import i18n from '../../lang/i18n';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import useWindowDimensions from 'components/Dimention';
import { swipeModalWidth } from 'utils/helper';

const LanguageInformation = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { width } = useWindowDimensions();
  const isSmallScreen = width <= swipeModalWidth;

  const [language, setLanguage] = useState(
    localStorage.getItem('language') || 'en'
  );

  useEffect(() => {
    const handleLanguageChange = (lng) => {
      setLanguage(lng);
    };
    i18n.on('languageChanged', handleLanguageChange);

    return () => {
      i18n.off('languageChanged', handleLanguageChange);
    };
  }, []);

  const handleChange = (event) => {
    const langCode = event.target.value;
    setLanguage(langCode);
    handleLangChange(langCode);
  };

  const handleLangChange = (langCode) => {
    i18n.changeLanguage(langCode);
    localStorage.setItem('language', langCode);
  };

  return (
    <SettingsStyles>
      <div className="setting-info-container">
        <div className="setting-title">
          {isSmallScreen && (
            <CloseIcon
              customStyle="back-icon"
              iconType="back"
              onClick={() => navigate('/settings')}
            />
          )}
          {t('Settings.Language')}
        </div>
        <div className="setting-action-content">
          <Select
            Options={LanguageList}
            label={t('Settings.FavouriteLang')}
            value={language}
            onChange={handleChange}
            required
          />
        </div>
      </div>
    </SettingsStyles>
  );
};

export default LanguageInformation;
